module.exports = " <div class=im-container :style=\"{height: imHeight + 'px'}\" _v-eec1567c=\"\"> <dialog-container :scroller-height=dialogHeight :messages=messages :user-message=userMessage :is-check=isCheck :need-service=needService _v-eec1567c=\"\"></dialog-container> <editor-container _v-eec1567c=\"\"></editor-container> </div> <div class=mask v-show=showMask _v-eec1567c=\"\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-eec1567c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImContainer.vue
// module id = 69
// module chunks = 1